// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//
// NOT a scratch file. The test image is built with `npm run build`, which is
// `--configuration=development` and replaces nothing, so these URLs are what
// the deployed test portal asks for. Point them at localhost to debug and the
// test environment goes with you: every request leaves the browser for a host
// that is not there, and every card reports "Kunde inte na servern".
//
// To run against a local backend, override at serve time instead of editing
// this file - `ng serve` with your own configuration, or revert before pushing.

export const environment = {
  production: false,
  bookkeepUrl: 'https://api.dev1.wrebit.helops.net',
  adminUrl: 'https://api.dev1.wrebit.helops.net',
  socketUrl: 'https://api.dev1.wrebit.helops.net',
  apiUrl: 'https://api.dev1.wrebit.helops.net',
  villainUrl: 'https://villain.dev.wrebit.helops.net',
  baseAccountPlanId: '09c48fc1-4e62-49ff-9e96-febe5e3c454a',
  TOKEN_NAME: 'admin_jwt_token',
  ACTIVE_USER: 'admin_active_user',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
